/**
 * Created by razial on 18.09.2026.
 */

cleverapps.styles.PassHeaderPack[Offers.TYPES.CLPASS] = cleverapps.overrideStyles(cleverapps.styles.PassHeaderPackTemplate, {
    badge: {
        x: { align: "right", dx: 57 },
        y: { align: "center", dy: -48 }
    }
}, true);

cleverapps.styles.PassPackBadge[Offers.TYPES.CLPASS] = cleverapps.overrideStyles(cleverapps.styles.PassPackBadgeTemplate, {
    text: {
        x: { align: "center", dx: 16 },
        y: { align: "center", dy: 4 },
        rotation: 34
    }
}, true);
